import { getCmsAppDownloadLinkAndQr } from "../../../app/api/getCmsAppDownloadLinkAndQr";
import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ICmsAppDownloadLinkResponse } from "../../../Orchestrator/Types/Interface/ICmsAppDownloadLink";

class GetCmsAppDownloadLinksAndQrAction extends BaseAction<ICmsAppDownloadLinkResponse | null, void> {
  override async run(): Promise<ICmsAppDownloadLinkResponse | null> {
    let downloadResponse: ICmsAppDownloadLinkResponse | null = null;
    try {
      const response = await getCmsAppDownloadLinkAndQr();

      if (response.status === "ok" && response.answer) {
        downloadResponse = response.answer;
        updateRecoilState("cmsAppDownloadLinkResponseAtom", downloadResponse);
      } else {
        console.warn("Failed to fetch routes.");
      }
    } catch (error: any) {
      console.error("Error fetching routes:", error);
    } finally {
      return downloadResponse;
    }
  }
}

export const getCmsAppDownloadLinksAndQrAction = new GetCmsAppDownloadLinksAndQrAction()
